export default __webpack_public_path__ + "locales/si/ArchiveDialog.json?hash=30aa929f3537c40aae3503ab8c3ec33f";